export enum SVG_TEAM_KIT {
    SVG = '</svg>',
}
